<script setup lang="ts">
import { RouterView } from 'vue-router'
</script>

<template>
  <div class="min-h-dvh bg-neutral-950 text-neutral-100">
    <RouterView />
  </div>
</template>
